<script setup>
import { usePage } from '@inertiajs/vue3';

const { branding } = usePage().props;
</script>
<template>
  <footer
    class="text-grey-500 mt-8 mb-3 flex items-center justify-center gap-2"
  >
    Copyright &copy; {{ branding.copyright || branding.name }}
    <span>-</span>
    <a
      :href="branding.website"
      class="text-primary-600 hover:text-primary-500"
      target="_blank"
    >
      {{ $t('components.copyright.website') }}
    </a>
    <span v-if="branding?.web_policy" class="text-grey-500">|</span>
    <a
      v-if="branding?.web_policy"
      :href="branding?.web_policy"
      class="text-primary-600 hover:text-primary-500"
      target="_blank"
    >
      {{ $t('components.copyright.privacy_policy') }}
    </a>
  </footer>
</template>
